import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { getSpecificCategoryTemplate } from "../../../api/faceswap/categoryTemplate";
import { getRandomTemplates } from "../../../api/faceswap/template";
import { useMedia } from "../../../context/media-context";
import { useSelectedOption } from "../../../context/media-context/SelectedOptionContext";
import { handleApiError } from "../../../utils/common";
import MessageDisplay from "../../common/ErrorDisplay";
import MediaList from "../../media/Media";

export default function Photo() {
  const { setMedia } = useMedia();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { setSelectedOption } = useSelectedOption();

  // Constants and state
  const categoryOrder = searchParams.get("category_order") || null;
  const pagination = searchParams.get("pagination") || 10;
  const page = searchParams.get("page") || 1;

  // Query to fetch data based on category or randomly
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: categoryOrder
      ? ["getSpecificCategoryTemplate", categoryOrder, page, pagination]
      : ["getRandomTemplates", page, pagination],
    queryFn: () => {
      return categoryOrder
        ? getSpecificCategoryTemplate(categoryOrder, page, pagination)
        : getRandomTemplates(page, pagination);
    },
    onError: (error) => {
      handleApiError(error);
      console.error("Error fetching templates:", error);
    },
    keepPreviousData: true,
  });

  // Function to retry fetching data in case of error
  const handleRetry = () => refetch();
  useEffect(() => {
    if (location.pathname === "faceswap/photos" && location.search === "") {
      setSelectedOption(null);
    }
  }, [location.pathname, location.search, setSelectedOption]);

  useEffect(() => {
    if (data) {
      setMedia(data.data); // Set media only if data exists
    }
  }, [data]);

  if (error) {
    return (
      <MessageDisplay
        type="error"
        message="Failed to load data!"
        onAction={handleRetry}
      />
    );
  }

  return (
    <MediaList
      mediaType="photos"
      media={data?.data}
      isLoading={isLoading}
      category={categoryOrder}
    />
  );
}
